import humps from 'humps';

const convertCallback = (key, convert) => {
  const lastSymbol = key.slice(-1);
  const newKey = convert(key);
  return lastSymbol === '-' ? `${newKey}-` : newKey;
};

export const camelize = obj => humps.camelizeKeys(obj, convertCallback);

const decamelizeOptions = { split: /(?=[A-Z])/ };

export const decamelize = object => {
  if (object && !(object instanceof File)) {
    if (object instanceof Array) {
      return object.map(item => decamelize(item, decamelizeOptions));
    }
    if (typeof object === 'object') {
      return Object.keys(object).reduce(
        (acc, next) => ({
          ...acc,
          [humps.decamelize(next, decamelizeOptions)]: decamelize(object[next], decamelizeOptions),
        }),
        {},
      );
    }
  }

  return object;
};

export const mapDatesToISO = object => {
  if (object && !(object instanceof File)) {
    if (object instanceof Array) {
      return object.map(item => mapDatesToISO(item));
    }
    if (typeof object.toISOString === 'function') {
      return object.toISOString();
    }
    if (typeof object === 'object') {
      return Object.keys(object).reduce(
        (acc, next) => ({
          ...acc,
          [next]: mapDatesToISO(object[next]),
        }),
        {},
      );
    }
  }

  return object;
};
